import {useCallback, useEffect, useState} from "react";

import {UserPhoneVerificationForm, UserUpdatePhoneNumberForm} from "@pg-mono/user";

import {closeFlow, RegistrationFlowStep} from "../../../auth/state/registration_flow_slice";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";
import {UserPhoneVerificationProvider} from "../../../user/providers/UserPhoneVerificationProvider";
import {UserUpdatePhoneNumberModalProvider} from "../../../user/providers/UserUpdatePhoneNumberModalProvider";
import {closeAuthDrawer} from "../../state/semantic_search_auth_slice";

const PhoneVerificationBody = () => {
    const dispatch = useAppDispatch();
    const registrationFlow = useAppSelector((state) => state.registrationFlow);
    const {data: userProfile, refetch} = useGetUserProfileQuery();
    const [changeNumberRequested, setChangeNumberRequested] = useState(false);
    const [pinFormKey, setPinFormKey] = useState(0);

    const hasPhoneNumber = Boolean(userProfile?.phone?.trim());
    const showUpdatePhone = changeNumberRequested || (userProfile != null && !hasPhoneNumber);

    const handleCloseUpdatePhoneStep = useCallback(() => {
        setChangeNumberRequested(false);
    }, []);

    useEffect(() => {
        if (
            registrationFlow.isActive &&
            (registrationFlow.currentStep === RegistrationFlowStep.PHONE_VERIFICATION || registrationFlow.currentStep === RegistrationFlowStep.PHONE_COMPLETION)
        ) {
            dispatch(closeFlow());
        }
    }, [dispatch, registrationFlow.isActive, registrationFlow.currentStep]);

    if (showUpdatePhone) {
        return (
            <UserUpdatePhoneNumberModalProvider onCloseOverride={handleCloseUpdatePhoneStep}>
                <UserUpdatePhoneNumberForm
                    isOpen
                    onSuccess={() => {
                        void refetch().then(() => {
                            setChangeNumberRequested(false);
                            setPinFormKey((k) => k + 1);
                        });
                    }}
                />
            </UserUpdatePhoneNumberModalProvider>
        );
    }

    return (
        <UserPhoneVerificationForm
            key={pinFormKey}
            isOpen
            onSuccess={() => {
                void refetch();
                dispatch(closeAuthDrawer());
            }}
            onChangeNumber={() => setChangeNumberRequested(true)}
        />
    );
};

export const SemanticSearchAuthPhoneVerificationForm = () => (
    <UserPhoneVerificationProvider>
        <PhoneVerificationBody />
    </UserPhoneVerificationProvider>
);
import {useCallback, useEffect, useState} from "react";

import {UserPhoneVerificationForm, UserUpdatePhoneNumberForm} from "@pg-mono/user";

import {closeFlow, RegistrationFlowStep} from "../../../auth/state/registration_flow_slice";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";
import {UserPhoneVerificationProvider} from "../../../user/providers/UserPhoneVerificationProvider";
import {UserUpdatePhoneNumberModalProvider} from "../../../user/providers/UserUpdatePhoneNumberModalProvider";
import {closeAuthDrawer} from "../../state/semantic_search_auth_slice";

const PhoneVerificationBody = () => {
    const dispatch = useAppDispatch();
    const registrationFlow = useAppSelector((state) => state.registrationFlow);
    const {data: userProfile, refetch} = useGetUserProfileQuery();
    const [changeNumberRequested, setChangeNumberRequested] = useState(false);
    const [pinFormKey, setPinFormKey] = useState(0);

    const hasPhoneNumber = Boolean(userProfile?.phone?.trim());
    const showUpdatePhone = changeNumberRequested || (userProfile != null && !hasPhoneNumber);

    const handleCloseUpdatePhoneStep = useCallback(() => {
        setChangeNumberRequested(false);
    }, []);

    useEffect(() => {
        if (
            registrationFlow.isActive &&
            (registrationFlow.currentStep === RegistrationFlowStep.PHONE_VERIFICATION || registrationFlow.currentStep === RegistrationFlowStep.PHONE_COMPLETION)
        ) {
            dispatch(closeFlow());
        }
    }, [dispatch, registrationFlow.isActive, registrationFlow.currentStep]);

    if (showUpdatePhone) {
        return (
            <UserUpdatePhoneNumberModalProvider onCloseOverride={handleCloseUpdatePhoneStep}>
                <UserUpdatePhoneNumberForm
                    isOpen
                    onSuccess={() => {
                        void refetch().then(() => {
                            setChangeNumberRequested(false);
                            setPinFormKey((k) => k + 1);
                        });
                    }}
                />
            </UserUpdatePhoneNumberModalProvider>
        );
    }

    return (
        <UserPhoneVerificationForm
            key={pinFormKey}
            isOpen
            onSuccess={() => {
                void refetch();
                dispatch(closeAuthDrawer());
            }}
            onChangeNumber={() => setChangeNumberRequested(true)}
        />
    );
};

export const SemanticSearchAuthPhoneVerificationForm = () => (
    <UserPhoneVerificationProvider>
        <PhoneVerificationBody />
    </UserPhoneVerificationProvider>
);
